/* eslint-disable */
import React, { Component } from 'react';
import {
  Paper, Grid, Typography, Switch, Button
} from '@material-ui/core';
import cloneDeep from 'lodash/cloneDeep';
import CreateAndEditWrapper from '../share/CreateAndEditWrapper';
import { resourceFormStyle, commonResourceStyle } from '../../css/style';
import {
  resourceFields,
  validationErrorMessages,
  currencyCodes,
  squareIdLettersAndNumbersOnly,
  payAtDoorOptionsList,
} from '../../data/Constants';
import FormTextField from '../share/FormTextField';
import OrderTimingTextField from '../share/OrderTimingTextField';
import * as utilFunctions from '../../utils/Functions';
import Hours from '../share/Hours';
import * as HoursUtils from '../../utils/HoursUtils';
import HolidayHours from '../share/HolidayHours';
import moment from 'moment';
import withStyles from '@material-ui/core/styles/withStyles';
import FormSwitchField from '../share/FormRadioField';
import FormDropDownField from '../share/FormDropDownField';
import NotificationsAndReportsField from './NotificationAndReportsField';
import get from 'lodash/get'

const styles = resourceFormStyle();
const commonStyles = commonResourceStyle();
const switchStyles = resourceFormStyle();
const IosSwitch = withStyles(switchStyles.iosSwitchStyles)(Switch);
class CreateAndEditLocation extends Component {
  constructor(props) {
    super(props);
    const { match, type, resources } = this.props;
    const { resource } = match.params;
    const fields = resourceFields[resource];
    const locationDetail = {};
    fields.forEach((field) => {
      const { key } = field;
      const detail = {
        ...field,
        value: '',
        errorMessage: '',
        isValid: true,
      };
      locationDetail[key] = detail;
    });
    if (type === 'edit') {
      const findEntityArgs = { resources, match };
      const itemToEdit = utilFunctions.findEntityByID(findEntityArgs);
      Object.values(locationDetail).forEach((detail) => {
        const { key } = detail;
        detail.value = !!itemToEdit ? itemToEdit[key] : '';
      });
    }
    this.state = {
      locationDetail,
    };
  }
  createRequestData = () => {
    const { locationDetail } = this.state;
    const copyOfLocationDetail = cloneDeep(locationDetail);
    const requestData = {};
    Object.values(copyOfLocationDetail).forEach(({ key, value }) => {
        if (key === 'holidayHours' && Array.isArray(value)) {
            value = value.map((holiday) => {
                if (holiday.id < 0) {
                    holiday.id = 0;
                }
                if (holiday.isClose) {
                    holiday.open = null;
                    holiday.close = null;
                }
                delete holiday.isClose;
                delete holiday.isError;
                return holiday;
            });
        } else if (key === 'hours' && Array.isArray(value)) {
          value = HoursUtils.consolidateHoursRecords(value);
        } else if ((key === 'orderNotification' || key === 'salesReport')) {
          if (get(value, 'id') &&  get(value, 'id') < 0) {
            value.id = 0;
          }
          if (Array.isArray(get(value, 'recipients'))) {
            value.recipients = value.recipients.map((recipient) => {
              if (recipient.id < 0) {
                recipient.id = 0;
              }
              return recipient;
            })
          }
        }
        const isEmergency = key === 'emergencyMessage' || key === 'emergencyTitle';
        const isPhoneNumber = key === 'phone';
        const isEmptyStringField = isEmergency || isPhoneNumber;
        requestData[key] = (value === '' && !isEmptyStringField) ? null : value;
    });
    return requestData;
  }
  validateSquareId = ({ newValue }) => {
    if (newValue === '' || newValue === null) return;
    if (newValue.length !== 13) return 'Square ID must be 13 characters in length.';
    if (squareIdLettersAndNumbersOnly.test(newValue)) {
      return;
    } else {
      return " Please enter only letters and numbers. SquareId cannot include special characters (for example, !@#$%)')`";
    }  
  }
  areFieldsValid = () => {
    const { locationDetail, isThisFieldInvalid } = this.state;
    let areAllValid = true;
    const copyOfLocationDetail = cloneDeep(locationDetail);
    const { isRequiredError } = validationErrorMessages.field;
    Object.values(copyOfLocationDetail).forEach((detail) => {
      const { isRequired, value } = detail;
      if (isRequired && !value) {
        detail.isValid = false;
        detail.errorMessage = isRequiredError;
        areAllValid = false;
      } else if (!detail.isValid) {
        areAllValid = false;
      }
    });
    if (isThisFieldInvalid) { 
        areAllValid = false;
    }
    if (!areAllValid) {
      this.setState({
        locationDetail: copyOfLocationDetail,
      });
    }
    return areAllValid;
  }
  editLocationAndSquareServer = (apiToken, requestData, resourceId) => {
    const { history, actions, match } = this.props;
    const { resource } = match.params;
    const { currencyCode, squareId, ...location } = requestData;
    const newSquareServer = { squareId, currencyCode };
    actions.addResource(apiToken, newSquareServer, 'square-servers').then(async (res) => {
      if (res.error) return;
      const squareServerId = res.response.id;
      const resourcePath = ['locations', resourceId, 'square-server', squareServerId];
      await actions.updateResource(apiToken, location, ...resourcePath);
      history.push(`/${resource}`);
    });
  }
  onClickApplyChanges = async () => {
    const {
      actions, resources, history, apiToken, match, type, admin,
    } = this.props;
    const {
      resource, resourceId
    } = match.params;
    const requestData = this.createRequestData();
    let resourcePath = type === 'edit' ? [resource, resourceId] : [resource];
    if (!this.areFieldsValid()) {
      return;
    }
    const { updateResource, addResource } = actions;
    const action = type === 'edit' ? updateResource : addResource;
    const isSquare = get(admin, 'company.posIntegration') === 'SQUARE';
    const isCreateNonSquareLoc = type === 'create' && !isSquare;
    if (type === 'edit' || isCreateNonSquareLoc) {
      const originalLocation = get(resources, 'locations', []).find(location => `${location.id}` === `${resourceId}`);
      const originalSquareId = originalLocation && originalLocation.squareId ? originalLocation.squareId : null;
      const newSquareId = requestData.squareId;
      const originalCurrency = originalLocation && originalLocation.currencyCode ? originalLocation.currencyCode: null;
      const newCurrency = requestData.currencyCode;
      if (isSquare && (newSquareId !== originalSquareId || newCurrency !== originalCurrency)) {
        this.editLocationAndSquareServer(apiToken, requestData, resourceId);
        return;
      }
      this.addOrUpdateLocationConfiguration(resourceId, requestData);
      action(apiToken, requestData, ...resourcePath).then(async (res) => {
        if (res.error) {
          return;
        }
        history.push(`/${resource}`);
      });
    } else if (type === 'create') {
      const squareServer = { squareId: requestData.squareId, currencyCode: requestData.currencyCode };
      action(apiToken, squareServer, 'square-servers').then(async (res) => {
        if (res.error) return;
        const { currencyCode, squareId, ...location } = requestData;
        const squareServerId = res.response.id;
        resourcePath = ['locations', 'square-server', squareServerId];
        await action(apiToken, location, ...resourcePath).then((newLocation) => {
          if (newLocation.response) {
            const newLocationID = newLocation.response.id;
            this.addOrUpdateLocationConfiguration(newLocationID, requestData);
          }
        });
        history.push(`/${resource}`);
      });
    }
  }
  addOrUpdateLocationConfiguration = (locationID, stateSnapshot) => {
    const { apiToken, actions } = this.props;
    ['DELIVERY_WINDOW', 'PICKUP_WINDOW'].forEach((code) => {
      const payload = {
        location: { id: locationID },
        code,
        value: stateSnapshot[code],
        dataType: 'LONG',
        isVisibleToAdmin: true,
        isVisibleToMobile: true,
      };
      actions.addResource(apiToken, payload, 'configuration');
    });
  }
  handleValueChange = ({ newValue, key, errorMsg }) => {
    const { locationDetail } = this.state;
    const updatedDetail = cloneDeep(locationDetail);
    const updatedField = updatedDetail[key];
    updatedField.value = newValue;
    updatedField.errorMessage = errorMsg;
    updatedField.isValid = !updatedField.errorMessage;
    this.setState({
        locationDetail: updatedDetail,
    });
  }
  hoursValidation = (hourObjs) => {
    let isThisFieldInvalid = false;

    const hoursTabsWithErrors = { business: false, delivery: false, pickup: false };

    for (let i = 0; i < hourObjs.length; i++) {
      const hourRecord = hourObjs[i];

      const { isAllHourTypesValid, doTabsHaveErrors } = HoursUtils.getIsHourValidResults(hourRecord);
      if (!isAllHourTypesValid) isThisFieldInvalid = true;
      doTabsHaveErrors.forEach(([tab, hasErrorResult]) => {
        const tabAlreadyHasErrors = hoursTabsWithErrors[tab];
        const tabNowHasErrors = tabAlreadyHasErrors || hasErrorResult;
        hoursTabsWithErrors[tab] = tabNowHasErrors;
      });
    }

    const { tabsWithOverlaps, hoursHaveOverlaps } = HoursUtils.getHasOverlapsSummary(hourObjs);
    tabsWithOverlaps.forEach(([tab, hasErrorResult]) => {
      const tabAlreadyHasErrors = hoursTabsWithErrors[tab];
      const tabNowHasErrors = tabAlreadyHasErrors || hasErrorResult;
      hoursTabsWithErrors[tab] = tabNowHasErrors;
    });
    if (hoursHaveOverlaps) isThisFieldInvalid = true;

    this.setState({ hoursTabsWithErrors, isThisFieldInvalid });
  }
  handleHourChange = (hours) => {
    this.hoursValidation(hours);
    const { locationDetail } = this.state;
    const updatedDetail = cloneDeep(locationDetail);
    const updatedField = updatedDetail['hours'];
    updatedField.value = hours;
    this.setState({
        locationDetail: updatedDetail,
    });
  }
  onChangeHolidayHour = (ids, key, value) => {
    const { locationDetail } = this.state;
    const updatedDetail = cloneDeep(locationDetail);
    const updatedField = updatedDetail['holidayHours'];
    const holidayHours = updatedField.value;
    const updatedHolidayHours = holidayHours.map((holiday) => {
      if (ids.includes(holiday.id)) {
        if (key === 'isClose' && value === true && holiday.open == null && holiday.close == null) {
          holiday.open = moment().format('HH:mm');
          holiday.close = moment().format('HH:mm');
        }
        holiday[key] = value;
        holiday.isError = holiday.open > holiday.close;
      }
      return holiday;
    });
    updatedField.value = updatedHolidayHours;
    updatedField.isValid = !updatedHolidayHours.some(hour => hour.isError);
    this.setState({ locationDetail: updatedDetail });
  }

  onAddHolidayHour = (date, businessOpenAllDay) => {
    const { locationDetail } = this.state;
    const updatedDetail = cloneDeep(locationDetail);
    const updatedField = updatedDetail['holidayHours'];
    const newHolidayHour = {
      id: -Date.now(),
      date: date || Date.now() / 1000,
      businessOpenAllDay: !!businessOpenAllDay,
      open: moment().format('HH:mm'),
      close: moment().format('HH:mm'),
    };
    updatedField.value = updatedField.value ? [...updatedField.value, newHolidayHour] : [newHolidayHour];
    this.setState({ 
        locationDetail: updatedDetail,
    });
  }

  onDeleteHolidayHour = (holidayHourToDeleteId) => {
    const { locationDetail } = this.state;
    const updatedDetail = cloneDeep(locationDetail);
    const updatedField = updatedDetail['holidayHours'];
    const deletedHolidayHours = updatedField.value.filter(holiday => holiday.id != holidayHourToDeleteId);
    updatedField.value = deletedHolidayHours;
    this.setState({ 
        locationDetail: updatedDetail 
    });
  }

  onDeleteRecipient = (id, isSales) => {
    const { locationDetail } = this.state;
    const { actions, apiToken, match } = this.props;
    const { resource, resourceId } = match.params;
    const notificationOrReport = isSales ? 'salesReport' : 'orderNotification';
    const updatedDetail = cloneDeep(locationDetail);
    const updatedField = isSales ? updatedDetail['salesReport'] : updatedDetail['orderNotification'];
    const filteredRecipients = updatedField.value.recipients.filter(recipient => recipient.id != id);
    updatedField.value.recipients = filteredRecipients;
    this.setState({ 
      locationDetail: updatedDetail 
    });
    if (id > 0) {
      actions.deleteResource(apiToken, ...[resource, resourceId, notificationOrReport, 'recipients', id]);
    }
  }

  onChangeRecipient = (isSales, key, value, id, dropdownOptions) => {
    const { locationDetail } = this.state;
    const updatedDetail = cloneDeep(locationDetail);
    const updatedField = isSales ? updatedDetail['salesReport'] : updatedDetail['orderNotification'];
    const updatedRecipients = updatedField.value.recipients.map((recipient) => {
      if (id === recipient.id) {
        if (key === 'email') {
          recipient.email = value;
        } else {
            dropdownOptions.forEach((option) => {
              if (option.id === value) {
                isSales ? recipient.reportFrequency = option.value : recipient.orderType = option.value;
              }
            })
        }
      }
      return recipient;
    });
    updatedField.value.recipients = updatedRecipients;
    this.setState({ locationDetail: updatedDetail });
  }

  onAddRecipient = (isSales) => {
    const { locationDetail } = this.state;
    const updatedDetail = cloneDeep(locationDetail);
    const updatedField = isSales ? updatedDetail['salesReport'] : updatedDetail['orderNotification'];
    const newRecipient = isSales ? {
      id: -Date.now(),
      email: '',
      reportFrequency: '',
    } : {
      id: -Date.now(),
      email: '',
      orderType: '',
    };
    updatedField.value.recipients = updatedField.value.recipients ?
      [...updatedField.value.recipients, newRecipient] : [newRecipient];
    this.setState({
      locationDetail: updatedDetail
    });
  }

  onSwitchRecipient = (isSales) => {
    const { locationDetail } = this.state;
    const updatedDetail = cloneDeep(locationDetail);
    const updatedField = isSales ? updatedDetail['salesReport'] : updatedDetail['orderNotification'];
    if (!updatedField.value) {
      updatedField.value = {
        id: -Date.now(),
        enabled: true,
        recipients: null,
      };
    } else {
      updatedField.value.enabled = !updatedField.value.enabled;
    }
    this.setState({
      locationDetail: updatedDetail
    });
  }

  renderNotificationAndReportRecipient = (isSales) => {
    const { locationDetail } = this.state;
    const field = isSales ? locationDetail['salesReport'] : locationDetail['orderNotification'];
    if (field.value && field.value.recipients && field.value.enabled && field.value.recipients.length > 0) {
      return (
        <NotificationsAndReportsField
          data={field.value.recipients}
          onAdd={this.onAddRecipient}
          isSales={isSales}
          onChange={this.onChangeRecipient}
          onDeleteRecipient={this.onDeleteRecipient}
        />
      )
    } else if (field.value && (!field.value.recipients || field.value.recipients.length < 1) && field.value.enabled) {
      return (
        <Button 
          style={styles.addRecipientButton}
          onClick={() => this.onAddRecipient(isSales)}                
        >
          Add Recipient
        </Button>
      )
    } else {
      return;
    }
  }

  render() {
    const {
        locationDetail, hoursTabsWithErrors
    } = this.state;
    const {
      name,
      phone,
      address,
      holidayHours,
      hours,
      deliveryTime,
      pickupTime,
      DELIVERY_WINDOW,
      PICKUP_WINDOW,
      emergencyTitle,
      emergencyMessage,
      currencyCode,
      squareId,
      orderNotification,
      salesReport,
      payAtDoorAvailable,
      payAtDoorOptions,
      payNowAvailable,
    } = locationDetail;
    const { admin } = this.props;
    const hintText = 'This updates the text on the ASAP Button.'
    return (
      <CreateAndEditWrapper
        {...this.props}
        onClickApplyChanges={this.onClickApplyChanges}
      >
        <Paper style={commonStyles.paperNoHeight}>
          <form noValidate autoComplete="off" style={styles.formContainer}>
            <Grid
              container
              spacing={24}
              style={styles.gridContainerBordered}
            >
                <div style={styles.itemTitleContainer}>
                    <Typography style={styles.gridContainerTitle}>Location Information</Typography>
                </div>
                <FormTextField
                    field={name}
                    handleValueChange={this.handleValueChange}
                />
                <FormTextField
                    field={phone}
                    handleValueChange={this.handleValueChange}
                />
                <FormTextField
                    field={address}
                    handleValueChange={this.handleValueChange}
                />
            </Grid>
            <Grid
              container
              spacing={0}
              style={styles.gridContainerBordered}
              direction='column'
              >
                <div style={styles.itemTitleContainer}>
                  <Typography style={styles.gridContainerTitle}>Payment Options</Typography>
                </div>
                <div style={styles.columnFieldPadding}>
                  <FormSwitchField
                    field={payNowAvailable}
                    handleValueChange={this.handleValueChange}
                  />
                </div>
                <div style={styles.columnFieldPadding}>
                  <FormSwitchField
                    field={payAtDoorAvailable}
                    handleValueChange={this.handleValueChange}
                  />
                </div>
                <div style={styles.columnFieldPadding}>
                  <FormDropDownField
                    field={payAtDoorOptions}
                    dropdownOptions={payAtDoorOptionsList}
                    handleValueChange={this.handleValueChange}
                    allowMultiple
                  />
                </div>
              </Grid>
            <Grid
              container
              spacing={24}
              style={styles.gridContainerBordered}
            >
                <div style={styles.itemTitleContainer}>
                    <Typography style={styles.gridContainerTitle}>Location Hours</Typography>
                </div>
                <Hours 
                    data={hours.value}
                    onChange={this.handleHourChange}
                    hoursTabsWithErrors={hoursTabsWithErrors}
                />
            </Grid>
            <Grid
              container
              spacing={24}
              style={styles.gridContainerBordered}
            >
                <div style={styles.itemTitleContainer}>
                    <Typography style={styles.gridContainerTitle}>Holiday Hours</Typography>
                </div>
                <HolidayHours
                    data={holidayHours.value} 
                    onChangeHolidayHour={this.onChangeHolidayHour}
                    onAddHolidayHour={this.onAddHolidayHour}
                    onDeleteHolidayHour={this.onDeleteHolidayHour}
                />
            </Grid>
            <Grid
              container
              spacing={0}
              style={styles.gridContainerBordered}
            >
              <div style={styles.itemTitleContainer}>
                <Typography style={styles.gridContainerTitle}>Order Timing</Typography>
              </div>
              <Grid
                direction='column'
                style={styles.gridContainerColumn}
                spacing={0}
              >
                <div style={{marginBottom: "20px"}}>
                  <OrderTimingTextField
                    field={pickupTime}
                    handleValueChange={this.handleValueChange}
                  />
                  <OrderTimingTextField
                    field={PICKUP_WINDOW}
                    handleValueChange={this.handleValueChange}
                  />
                  <Typography style={styles.hintText}>{hintText}</Typography>
                </div>
                <div>
                  <OrderTimingTextField
                    field={deliveryTime}
                    handleValueChange={this.handleValueChange}
                    isColumn
                  />
                  <OrderTimingTextField
                    field={DELIVERY_WINDOW}
                    handleValueChange={this.handleValueChange}
                    isColumn
                  />
                  <Typography style={styles.hintText}>{hintText}</Typography>
                </div>
              </Grid>
            </Grid>
            <Grid
              container
              spacing={24}
              style={styles.gridContainerBordered}
            >
              <div style={styles.itemTitleContainerOneLine}>
                <Typography style={styles.gridContainerTitle}>Order Limiting</Typography>
                <IosSwitch
                  disabled
                />
              </div>
            </Grid>
            <Grid
              container
              spacing={24}
              style={styles.gridContainerBordered}
            >
              <div style={styles.itemTitleContainer}>
                <Typography style={styles.gridContainerTitle}>Service Fees</Typography>
              </div>
              <Button style={styles.button} disabled>Add New Service Fee</Button>
            </Grid>
            <Grid
              container
              spacing={0}
              style={styles.gridContainerBordered}
              direction='column'
            >
              <div style={styles.itemTitleContainer}>
                <Typography style={styles.gridContainerTitle}>Notifications + Reports</Typography>
              </div>
              <div style={styles.notificationReportsTitleContainer}>
                <Typography style={styles.recipientTitle}>Order Notification Recipient</Typography>
                <IosSwitch
                  checked={orderNotification.value ? orderNotification.value.enabled : false}
                  onChange={() => this.onSwitchRecipient(false)}
                />
              </div>
              <div style={styles.recipientsContainer}>
                { this.renderNotificationAndReportRecipient(false) }
              </div>
              <div style={styles.notificationReportsBorder} />
              <div style={styles.notificationReportsTitleContainer}>
                <Typography style={styles.recipientTitle}>Sales Report Recipient</Typography>
                <IosSwitch
                  checked={salesReport.value ? salesReport.value.enabled : false}
                  onChange={() => this.onSwitchRecipient(true)}
                />
              </div>
              <div style={styles.recipientsContainer}>
                { this.renderNotificationAndReportRecipient(true) }
              </div>
            </Grid>
            <Grid
              container
              spacing={0}
              style={styles.gridContainerBordered}
              direction='column'
            >
                <div style={styles.itemTitleContainer}>
                    <Typography style={styles.gridContainerTitle}>Emergency Message</Typography>
                </div>
                <div style={styles.columnFieldPadding}>
                  <FormTextField
                      field={emergencyTitle}
                      handleValueChange={this.handleValueChange}
                  />
                </div>
                <div style={styles.columnFieldPadding}>
                  <FormTextField
                      isMultipleRow
                      field={emergencyMessage}
                      handleValueChange={this.handleValueChange}
                  />
                </div>
            </Grid>
            { admin.company.posIntegration === 'SQUARE' && (
              <Grid
              container
              spacing={0}
              style={styles.gridContainerBordered}
              direction='column'
              >
                <div style={styles.itemTitleContainer}>
                  <Typography style={styles.gridContainerTitle}>Square Related Fields</Typography>
                </div>
                <div style={styles.columnFieldPadding}>
                  <FormTextField
                    field={squareId}
                    handleValueChange={this.handleValueChange}
                    customValidator={this.validateSquareId}
                  />
                </div>
                <div style={styles.columnFieldPadding}>
                  <FormDropDownField
                    field={currencyCode}
                    dropdownOptions={currencyCodes}
                    handleValueChange={this.handleValueChange}
                  />
                </div>
              </Grid>
            )}
          </form>
        </Paper>
      </CreateAndEditWrapper>
    );
  }
}
export default CreateAndEditLocation;
